import {
  Button,
  Divider,
  Flex,
  Form,
  Modal,
  Select,
  Typography,
  Upload,
} from 'antd'
import { useUnit } from 'effector-react'
import { BASE_URL, prizeTypesOptions } from 'src/pages/worldCup2026/const'
import { addWinnersFx, showError } from 'src/pages/worldCup2026/winners/model'

type Props = {
  isVisible: boolean
  onClose: () => void
}

export const AddWinnersModal = ({ isVisible, onClose }: Props) => {
  const [form] = Form.useForm()
  const { Item } = Form
  const { Text } = Typography
  const loading = useUnit(addWinnersFx.pending)

  const handleOk = async () => {
    try {
      const { prizeType, tickets } = await form.validateFields()
      await addWinnersFx({
        url: `${BASE_URL}winner/bulk`,
        body: { prizeType, tickets },
      })
      form.resetFields()
      onClose()
    } catch (error) {
      console.log('Validation failed:', error)
    }
  }

  const handleCancel = () => {
    form.resetFields()
    onClose()
  }

  return (
    <Modal
      title={<div style={{ fontSize: 20 }}>Add winners</div>}
      centered
      wrapClassName="ant_modal"
      width={700}
      maskClosable={false}
      open={isVisible}
      confirmLoading={loading}
      okText="Submit"
      onOk={handleOk}
      onCancel={handleCancel}
    >
      <Divider />
      <Flex vertical gap="small" align="flex-start">
        <Form form={form} layout="vertical">
          <Item
            required={false}
            name="prizeType"
            label={
              <Text style={{ fontSize: 16 }} strong>
                Prize type
              </Text>
            }
            rules={[
              {
                required: true,
                message: 'Required field',
              },
            ]}
          >
            <Select
              placeholder="Select prize type"
              options={prizeTypesOptions}
              style={{ width: 300 }}
            />
          </Item>
          <Item
            name="tickets"
            required={false}
            shouldUpdate
            style={{ height: 70 }}
            rules={[
              {
                required: true,
                message: 'Please upload a file',
              },
            ]}
          >
            <Upload
              accept=".csv"
              showUploadList={{
                showRemoveIcon: true,
              }}
              beforeUpload={(file) => {
                const reader = new FileReader()

                reader.onload = (e) => {
                  try {
                    const result = e.target?.result as string
                    const tickets = result
                      .replaceAll('\r', '')
                      .split('\n')
                      .filter((item) => Boolean(item))
                      .map((item) => Number(item))
                    form.setFieldsValue({ tickets })
                  } catch (err) {
                    showError(err as Error)
                    form.setFieldsValue({ tickets: undefined })
                  }
                }
                reader.readAsText(file)

                return false
              }}
            >
              <Button>Click to Upload</Button>
            </Upload>
          </Item>
        </Form>
      </Flex>
    </Modal>
  )
}
